/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Days_ColInputs */

const vi_customer_debt_days_col = /** @type {(inputs: Customer_Debt_Days_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số ngày nợ`)
};

/**

* @param {Customer_Debt_Days_ColInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_days_col = /** @type {((inputs?: Customer_Debt_Days_ColInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Days_ColInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_days_col(inputs)
});